<template>
  <table class="cus-addable-table form-file-table" :name="options.Key">
    <colgroup>
      <col style="width: 50px" />
      <col />
      <col style="width: 320px" />
    </colgroup>
    <tbody>
      <tr class="cus-table-thead">
        <td style="width: 50px">序号</td>
        <td>附件名称</td>
        <td style="width: 80px">附件</td>
      </tr>
      <tr v-for="(obj, i) in rows" :key="i">
        <td>
          <p>{{ i + 1 }}</p>
        </td>
        <td>
          <p>{{ obj.name }}</p>
          <p v-for="(item, j) in obj.nameRequire" :key="j" :class="obj.isUpload ? 'red' : ''">文件命名要求：{{ item }}</p>
        </td>
        <td>
          <p class="cat-p1">
            <el-form-item
              v-msg
              class="tender-form-label"
              label-width="0"
              :prop="`${options.Key}[${i}].val`"
              :name="obj.key"
              :rules="[{ required: obj.isUpload, message: '请上传' }]">
              <bear-upload-dialog v-model="obj.val" @input="inputChangeHandle"></bear-upload-dialog>
            </el-form-item>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import formUtils from "../../../js/formUtils";
import BearUploadDialog from "~@/upload-dialog/src";

import { tenderProjectConfig } from "@store/tender/modules/waterStore";
export default {
  name: "FormFileTable",
  components: {
    BearUploadDialog,
  },
  mixins: [mixForFormItem],
  computed: {
    requiredColumns() {
      const x = 0;
      return this.rows.filter((obj) => obj.isUpload !== false).length + x;
    },
    value() {
      let { options, form } = this;
      return form[options.Key];
    },
  },
  data() {
    return {
      rows: [],
    };
  },
  created() {
    this.init();

    this.setDefaultValue();
  },
  methods: {
    init() {
      let { form = {}, options } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          if (!form[options.Key]) {
            if (form.regionId.indexOf("3502") === 0) {
              /* 厦门 */
              form[options.Key] = tenderProjectConfig.XM_FILE_LIST;
            } else if (form.regionId.indexOf("3505") === 0) {
              /* 泉州 */
              form[options.Key] = tenderProjectConfig.QZ_FILE_LIST;

              if (form.regionId === "350582") {
                for (let i = 0; i < form[options.Key].length; i++) {
                  if (form[options.Key][i].name === "工程预算书") {
                    form[options.Key][i].isUpload = true;
                    break;
                  }
                }
              }
            } else if (form.regionId.indexOf("35") === 0 || form.regionId == "x60004") {
              /* 福建省或福建省国资采购 */
              form[options.Key] = tenderProjectConfig.FJGGZY_FILE_LIST;
            }
            this.rows = form[options.Key];
            this.$nextTick(() => {
              this.doValidate();
            });
          }
        })
        .catch((e) => null);
    },
    setDefaultValue() {
      let { form = {}, options } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          if (options.Value) {
            form[options.Key] = options.Value;
            this.rows = options.Value;
          } else {
            form[options.Key] = this.rows;
          }
          this.$nextTick(() => {
            this.doValidate();
          });
        })
        .catch(() => {
          this.rows = form[options.Key];
          this.$nextTick(() => {
            this.doValidate();
          });
        });
    },
    inputChangeHandle() {
      this.doValidate();
    },
    getRequiredCount() {
      return this.requiredColumns;
    },
  },
  watch: {
    value() {
      this.rows = this.value;
      this.$nextTick(() => {
        this.doValidate();
      });
    },
  },
};
</script>
<style lang="scss">
.cus-addable-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  thead,
  .cus-table-thead {
    background: #eef1f6;
  }
  th,
  td {
    padding: 10px;
    vertical-align: top;
    border: 1px solid #dfe6ec;
  }
  .text-left {
    text-align: left;
  }
  .cat-p1 {
    margin: 0;
    // width: 95px;
    text-align: left;
    .el-form-item {
      display: inline;
      margin-right: 0;
    }
  }
}
.form-file-table {
  .el-form-item--default,
  .el-form-item {
    .el-form-item__content {
      display: block;
    }
  }
}
</style>